module.exports = __webpack_public_path__ + "static/media/8m.f6e369a9.png";